import { motion } from "motion/react";
import Breadcrumbs from "@/theme1/components/shop/Breadcrumbs";

export default function ShopHeader({ title, description, image, imageAlt }) {
  return (
    <motion.header
      initial={{ opacity: 0, y: 28 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.65, ease: "easeOut" }}
      className="relative overflow-hidden rounded-[2rem] bg-foreground px-6 py-10 text-background shadow-2xl shadow-black/15 sm:px-10 lg:px-14 lg:py-16"
    >
      {/* Background Image */}
      {image && (
        <div className="absolute inset-0 z-0">
          <img
            src={image}
            alt={imageAlt || title || "Shop header"}
            className="h-full w-full object-cover opacity-20"
          />
          {/* Dark overlay for text readability */}
          <div className="absolute inset-0 bg-gradient-to-r from-foreground/90 via-foreground/70 to-foreground/40" />
        </div>
      )}

      {/* Content */}
      <div className="relative z-10">
        <Breadcrumbs
          items={[
            { label: "Home", href: "/" },
            { label: "Shop", href: "/shop" },
          ]}
        />

        <div className="mt-10 max-w-4xl">
          <p className="text-sm uppercase tracking-[0.35em] text-background/60">
            Premium Store
          </p>
          <h1 className="mt-4 text-4xl font-semibold tracking-tight sm:text-6xl lg:text-7xl">
            {title}
          </h1>
          <p className="mt-5 max-w-2xl text-sm leading-7 text-background/70 sm:text-base">
            {description}
          </p>
        </div>
      </div>
    </motion.header>
  );
}